module.exports = __FOREMAN_VENDOR__PATTERNFLY_REACT_TOKENS__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__PATTERNFLY_REACT_TOKENS__"
// module id = @patternfly/react-tokens
// module chunks = 0 1 2